/** Fired when pending edits must be saved now (the Android app goes to the background). */
export const FLUSH_EVENT = "ronin:flush";
